
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import Link from "next/link";
const About = ({ t }) => {
    const about = t('home:about', {}, { returnObjects: true });
    return (<section className={'about'} id={"about"}>
            <picture>
                <source srcSet={`/img/pages/home/about/money_about.webp?v=2`} type="image/webp"/>
                <source srcSet={`/img/pages/home/about/money_about.png?v=2`}/>
                <img src={`/img/pages/home/about/money_about.png?v=2`} alt={`PEPE Dollar`} width={1870} height={320} className='money_img'/>
            </picture>
            <picture>
                <source media="(max-width: 768px)" srcSet={`/img/pages/home/about/about_tribune_small.webp?v=2`} type="image/webp"/>
                <source media="(min-width: 769px)" srcSet={`/img/pages/home/about/about_tribune.webp?v=2`} type="image/webp"/>
                <source media="(max-width: 768px)" srcSet={`/img/pages/home/about/about_tribune_small.png?v=2`}/>
                <source media="(min-width: 769px)" srcSet={`/img/pages/home/about/about_tribune.png?v=2`}/>
                <img src={`/img/pages/home/about/about_tribune.png?v=2`} alt={`PEPE Dollar`} width={1148} height={1402} className='tribune_img'/>
            </picture>
            <div className="container">
                <div className="about_wrapper">
                    <div className={'about_content'}>
                        <h2 className={'about_title'}>{about.title}</h2>
                        <p className={'about_text'}>{about.text_1}</p>
                        <p className={'about_text'}>{about.text_2}</p>
                        <Link className='buy_cta' prefetch={false} href={process.env.NEXT_PUBLIC_APP_URL}>
                            <img src={'/logo.svg'} alt={'Buy $PEPD'}/>
                            {about.cta} Pepe<span className={'buy_cta_black'}>Dollar</span>
                        </Link>
                    </div>
                    <picture>
                        <source media="(max-width: 768px)" srcSet={`/img/pages/home/about/about_picture_small.webp?v=3`} type="image/webp"/>
                        <source media="(min-width: 769px)" srcSet={`/img/pages/home/about/about_picture.webp?v=3`} type="image/webp"/>
                        <source media="(max-width: 768px)" srcSet={`/img/pages/home/about/about_picture_small.png?v=3`}/>
                        <source media="(min-width: 769px)" srcSet={`/img/pages/home/about/about_picture.png?v=3`}/>
                        <img src={`/img/pages/home/about/about_picture.png?v=3`} alt={`PEPE Dollar`} width={1805} height={1010} className='picture_img'/>
                    </picture>
                    <picture>
                        <source media="(max-width: 768px)" srcSet={`/img/pages/home/about/about_heroes_small.webp?v=4`} type="image/webp"/>
                        <source media="(min-width: 769px)" srcSet={`/img/pages/home/about/about_heroes.webp?v=4`} type="image/webp"/>
                        <source media="(max-width: 768px)" srcSet={`/img/pages/home/about/about_heroes_small.png?v=4`}/>
                        <source media="(min-width: 769px)" srcSet={`/img/pages/home/about/about_heroes.png?v=4`}/>
                        <img src={`/img/pages/home/about/about_heroes.png?v=4`} alt={`PEPE Dollar`} width={1658} height={724} className='heroes_img'/>
                    </picture>
                </div>
            </div>
        </section>);
};
export default About;

    async function __Next_Translate__getStaticProps__1989dd500d7__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//home/About/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1989dd500d7__ as getStaticProps }
  